import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff, Cloud, CloudOff } from 'lucide-react';
import { syncService } from '@/services/syncService';

const OnlineStatusBadge = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const updateStatus = async () => {
      setIsOnline(navigator.onLine);
      const count = await syncService.getPendingCount();
      setPendingCount(count);
    };

    const handleSyncEvent = (event) => {
      if (event.type === 'online') {
        setIsOnline(true);
      } else if (event.type === 'offline') {
        setIsOnline(false);
      } else if (event.type === 'sync_complete') {
        updateStatus();
      }
    };

    syncService.addListener(handleSyncEvent);
    updateStatus();

    // Update pending count every 10 seconds
    const interval = setInterval(updateStatus, 10000);

    return () => {
      syncService.removeListener(handleSyncEvent);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="flex items-center gap-3">
      {/* Online/Offline Status */}
      <div
        className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors duration-200 ${
          isOnline
            ? 'bg-[#C8E6C9] text-[#1B4D1F]'
            : 'bg-[#F5D5D8] text-[#6B1B23]'
        }`}
        data-testid="online-status-badge"
      >
        {isOnline ? (
          <>
            <Wifi className="w-4 h-4" />
            <span>Online</span>
          </>
        ) : (
          <>
            <WifiOff className="w-4 h-4" />
            <span>Offline</span>
          </>
        )}
      </div>

      {/* Pending Sync Count */}
      {pendingCount > 0 && (
        <div
          className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium bg-[#FFE4B5] text-[#5C3D0A]"
          data-testid="pending-sync-badge"
        >
          {isOnline ? <Cloud className="w-4 h-4" /> : <CloudOff className="w-4 h-4" />}
          <span>{pendingCount} Pending</span>
        </div>
      )}
    </div>
  );
};

export default OnlineStatusBadge;